import { render } from "./SegmentEditor.vue?vue&type=template&id=369df996&scoped=true&ts=true"
import script from "./SegmentEditor.vue?vue&type=script&lang=ts"
export * from "./SegmentEditor.vue?vue&type=script&lang=ts"

import "./SegmentEditor.vue?vue&type=style&index=0&id=369df996&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369df996"]])

export default __exports__